module.exports = __webpack_public_path__ + "img/footer_logo.01315ac6.png";